'use strict';
import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { FeatureAccessAPI } from '../services/api';

export default function useFeatureAccess() {
  const { isAuthenticated } = useAuth();
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!isAuthenticated) {
        setFeatures([]);
        setLoading(false);
        return;
      }
      setLoading(true);
      setError(null);
      try {
        const resp = await FeatureAccessAPI.myFeatures();
        if (!cancelled && resp?.is_success) {
          setFeatures(resp.features || []);
        }
      } catch (e) {
        if (!cancelled) setError(e?.message || 'Failed to load feature access');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated]);

  const hasFeature = useMemo(() => {
    const set = new Set(features);
    return (key) => set.has(String(key || '').toUpperCase());
  }, [features]);

  return { features, hasFeature, loading, error };
}


